import { Link} from "react-router-dom";
import { Row, Col, Container, Card} from 'react-bootstrap';
import Header from './header';
import '../config';
import Footer from "./footer";


const ShippingPolicy = ({ items, onRemoveItem, onAddItem, onUpdateQtyItem, subTotal, setCartItem, totalItems }) => {

  const divStyle = {
      border: '1px solid rgba(0, 0, 0, 0.175)',
      borderRadius: '5px',
  };

  const spanRequired = {
     color: 'red',
  }
  const pStyle = {
      fontSize: '20px',
      width: '100%',
  };

  return (
    <>
    
        <Header onAddItem={onAddItem} items={items} totalItems={totalItems} ></Header>
        <Container>
            
            <Row className='m-3'>
            
            <Card className='mt-2 p-2'>
              <Card.Body>
                <Row>
                    <Col xs="12">
                        <h1 className='mt-5'>Shipping Policy</h1>
                    </Col>
                </Row>
                
                
                <Row className="mt-3 g-0">
                    <Col>
                    <p>We want to ensure your shopping experience is smooth and hassle-free. Please read the following Shipping and Returns Policy carefully to understand how we handle shipping, returns, and exchanges.</p>
                    <p><h4>Shipping Information:</h4></p>
                    <p>
                    1. Processing Time: Orders are typically processed within 1-3 business days (excluding holidays and weekends) from the time of purchase. During peak seasons or promotions, processing times may be slightly longer.
                    <br></br>
                    2. Shipping Methods: We offer various shipping options at checkout, including standard and expedited shipping. The estimated delivery times and costs associated with each method will be displayed during the checkout process.
                    <br></br>
                    3. Shipping Destinations: We currently ship to addresses within the United States.
                    <br></br>
                    4. Shipping Confirmation: Once your order is shipped, you will receive a confirmation email containing your tracking number and a link to track your package’s progress.
                    <br></br>
                    5. Undeliverable Packages: In the event that a package is deemed undeliverable due to incorrect address information provided by the customer or refusal to accept delivery, we may contact you to arrange for reshipment. Additional shipping charges may apply.
                    <br></br>
                    6. Shipping From:  We use a third party fulfillment service to fulfill all of our orders. Fulfillment Center information
                    </p>
                    <p>Fulfillment Center <br></br>{global.config.terms.return_address}<br></br>{global.config.terms.return_address2}</p>
                    </Col>
                </Row>
                
                <Row className="mt-3 g-0">
                
                </Row>
                
                

              </Card.Body>
            </Card>
            </Row>

            
            
        </Container>
        <Footer />
        </>
  );
};

export default ShippingPolicy;
